import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import '../styles/EmployeeMaster.css';
import BloodGroupTable from '../components/BloodGroupTable';

const BloodGroup = () => {
     const [employees, setEmployees] = useState([]);
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/bloodgroup/add';

     const handleAddClick = () => {

          navigate('/bloodgroup/add');
     };

     const handleCloseModal = () => {
          navigate('/bloodgroup');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Blood Group Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Blood Group
                    </button>
               </div>

               <BloodGroupTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New BloodGroup</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <Tabs
                              tabs={[
                                   { title: 'General', content: <GeneralInfoForm /> },
                                   { title: 'Personal Info', content: <div>Coming Soon...</div> },
                                   { title: 'Contact Details', content: <div>Coming Soon...</div> },
                                   { title: 'Job Details', content: <div>Coming Soon...</div> },
                                   { title: 'Documents', content: <div>Coming Soon...</div> },
                              ]}
                         />
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" onClick={handleCloseModal}>
                              Close
                         </Button>
                         <Button variant="primary">
                              Save
                         </Button>
                    </Modal.Footer>
               </Modal>
          </div>
     );
};

export default BloodGroup;